<template>
  <div class="home container-d">
    <!-- banner -->
    <Banner />
    <!-- content -->
    <div
      class="home-content pt-11 pb-8"
      v-loading.fullscreen.lock="loading.main"
      element-loading-background="rgba(122, 122, 122, 0.5)"
    >
      <div class="container">
        <el-row :gutter="gutter">
          <el-col :xs="24" :sm="24" :md="12">
            <div class="inherit-h inherit-w bg-white-1">
              <div class="home-content-left">
                <!-- 轮播图： 精彩瞬间 -->
                <div class="home-content-left-row py-2 px-3 pb-3">
                  <h3 class="text-primary-sub">
                    <Badge bg="#0794a2" />
                    <span class="shadow-text ml-4 fs-xxl fw-600"
                      >STEM发布会精彩瞬间</span
                    >
                  </h3>
                  <Carousel :list="carousel" v-if="carousel.length" />
                </div>
                <div class="bg-white inherit-w" style="height: 0.5rem"></div>
                <!-- 视频回放 -->
                <div class="home-content-left-row py-2 px-3 pb-3">
                  <div>
                    <h3 class="text-primary-sub flex-one jc-between">
                      <div>
                        <Badge bg="#0794a2" />
                        <span class="shadow-text ml-4 fw-600 fs-xxl"
                          >新闻纵览</span
                        >
                      </div>
                      <span
                        class="cursor-p text-right text-black-2 fs-xl text-hover hover-move op-8"
                        @click="router.push('/news')"
                      >
                        查看更多 >>
                      </span>
                    </h3>
                    <NewsList
                      :list="newsList"
                      @on-click="({ id }) => router.push(`/news/${id}`)"
                      :loading="loading.main"
                    />
                  </div>

                  <div class="pt-1">
                    <h3 class="text-primary-sub flex-one jc-between">
                      <div>
                        <Badge bg="#0794a2" />
                        <span class="shadow-text ml-4 fw-600 fs-xxl"
                          >视频回放</span
                        >
                      </div>
                      <span
                        class="cursor-p text-right text-black-2 fs-xl text-hover hover-move op-8"
                        @click="router.push('/moment')"
                      >
                        查看更多 >>
                      </span>
                    </h3>
                    <VideoList
                      :list="videoList"
                      @on-play="onPlay"
                      v-if="videoList.length"
                    />
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <div class="bg-white-1 inherit-h inherit-w">
              <!-- 榜单 -->
              <div class="home-content-right py-2 px-3">
                <h3 class="shadow-text fw-600 text-primary-sub text-center">
                  {{ TITLE.homeRanking }}
                </h3>
                <Tabs :data="rankingTabs" @on-click="handleTabChange" />
                <TableItem
                  :tableData="tableValue"
                  :columns="tableColumns"
                  :loading="loading.table"
                />
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- float modal -->
    <template v-if="floatModalState">
      <FloatModal
        @on-click="handleClickFloatModal"
        :title="floatModalState.floatingTitle"
        :cover="FILE_URL + floatModalState.floatingCover"
      />
    </template>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { universityRank, hospitalRank } from '@/api/ranking.js'
import { newsList as reqNewsList } from '@/api/news.js'
import { listByYear } from '@/api/highlight.js'
import { setPV } from '@/api/config.js'

import {
  TABLE_COLUMNS,
  ISTEM_TABLE_COLUMNS,
  FILE_URL,
  TITLE
} from '@/config/constant.js'
import { result_types } from '@/config/sysEnum.js'
import { stemTypesFromHome } from '@/config/system.js'

import useSize from '@/hooks/useSize.js'

import TableItem from '@/components/table/index.vue'
import Badge from '@/components/badge/index.vue'
import FloatModal from '@/components/float-modal'

import Banner from './components/banner/index.vue'
import Carousel from './components/carousel/index.vue'
import VideoList from './components/video-list/index.vue'
import Tabs from './components/tabs/index.vue'
import NewsList from './components/list/index.vue'

import { parseTime } from '@/utils'

const router = useRouter()
const { getters } = useStore()

const loading = reactive({
  main: true,
  table: false
})
const { w } = useSize()

//精彩瞬间年份
const currentYear = ref(getters.currentYear.HIGH_LIGHT)
// 医院五年ASTEM年份
const currentHospitalAstemYear = ref(getters.currentYear.HOSPITAL_ASTEM)
// 医学院校年份
const currentUniversityYear = ref(getters.currentYear.UNIVERSITY)
// 医学院校五年ASTEM年份
const currentUniversityAstemYear = ref(getters.currentYear.UNIVERSITY_ASTEM)
// 医院年份
const currentHospitalYear = ref(getters.currentYear.HOSPITAL)
// 国际Stem年份
// const currentInternationalYear = ref(getters.currentYear.INTERNATIONAL_HOSPITAL)

/* ranking tabs */
const rankingTabs = ref(
  stemTypesFromHome
    .filter((s) => s.show)
    .sort((a, b) => {
      if (a.order > b.order) return 1
      if (a.order < b.order) return -1
      return 0
    })
)

const gutter = computed(() => {
  if (w.value >= 768) return 32
  return 0
})

//轮播图
const carousel = ref([])
//视频列表
const videoList = ref([])
//新闻列表
const newsList = ref([])
/* 当前的表格数据 */
const currentTable = ref(rankingTabs.value[0].value)

/* 排行榜数据 */
const rankingData = reactive({
  INTERNATIONAl: null,
  UNIVERSITY: null,
  HOSPITAL: null,
  UNIVERSITY_ASTEM: null,
  HOSPITAL_ASTEM: null
})

const tableValue = reactive([])

const tableColumns = computed(() => {
  if (currentTable.value === 'INTERNATIONAl') return ISTEM_TABLE_COLUMNS
  const name = result_types.getValueByLabel(currentTable.value.split('_')[0])
  TABLE_COLUMNS[1].name = name
  return TABLE_COLUMNS
})

/* 飘窗数据 */
const floatModalState = computed(() => {
  if (newsList.value && newsList.value.length) {
    const latestNews = newsList.value[0]
    return latestNews.floatingCover ? latestNews : null
  }
  return null
})

//切换tab
const handleTabChange = (value) => {
  loading.table = true
  currentTable.value = value
  tableValue.splice(0, tableValue.length)
  if (rankingData[value]) {
    tableValue.push(...rankingData[value])
  }
  loading.table = false
}

/**
 * 点击飘窗
 */
const handleClickFloatModal = () => {
  if (floatModalState.value) {
    router.push(`/news/${floatModalState.value.id}`)
  }
}

//播放
const onPlay = ({ id, index }) => {
  router.push(`/moment/${id}/video?index=${index}`)
}

// 轮播图、视频接口数据处理
const handleMomentRes = (res) => {
  if (!res.length) return
  //排序
  res.sort((a, b) => {
    if (a.year < b.year) return 1
    else if (a.year > b.year) return -1
    else return 0
  })
  const findInfo = res[0]
  if (findInfo) {
    const { highLightVideo: video, highLightPicture: picture, year } = findInfo
    if (findInfo.highLightPicture) {
      //轮播
      carousel.value = picture.pictureUris.map(({ uri }) => {
        return {
          id: new Date().getTime() + '',
          img: FILE_URL + uri
        }
      })
    }

    if (findInfo.highLightVideo) {
      //视频
      video.videoUris.forEach(({ cover, content }, index) => {
        // if (index > 2) return
        videoList.value.push({
          id: year,
          title: content,
          poster: FILE_URL + cover
        })
      })
    }
  }
}

/**
 * 请求数据
 */
const getData = async () => {
  Promise.all([
    // internationalRank({
    //   pageNum: 1,
    //   pageSize: 20,
    //   year: currentInternationalYear.value
    // }),
    universityRank({
      pageNum: 1,
      pageSize: 20,
      year: currentUniversityYear.value
    }),
    reqNewsList({
      pageNum: 1,
      pageSize: 4,
      keyword: ''
    }),
    listByYear({ year: currentYear.value })
  ])
    .then(([rankingRes, newsRes, momentRes]) => {
      rankingData.UNIVERSITY =
        rankingRes && rankingRes.records ? rankingRes.records : []

      handleMomentRes(momentRes)
      handleTabChange(currentTable.value)
      //news
      const news = newsRes && newsRes.records ? newsRes.records : []
      newsList.value = news.map((item) => {
        return {
          ...item,
          publishTime: parseTime(item.publishTime)
        }
      })
      loading.main = false
      loading.table = false
    })
    .catch((err) => {
      console.log(err)
    })

  hospitalRank({
    pageNum: 1,
    pageSize: 20,
    year: currentHospitalYear.value
  })
    .then((res) => {
      rankingData.HOSPITAL = res && res.records ? res.records : []
    })
    .catch(() => (rankingData.HOSPITAL = []))

  // universityRank({
  //   pageNum: 1,
  //   pageSize: 20,
  //   year: currentUniversityYear.value
  // })
  //   .then((res) => {
  //     rankingData.UNIVERSITY = res && res.records ? res.records : []
  //   })
  //   .catch(() => (rankingData.UNIVERSITY = []))

  hospitalRank({
    pageNum: 1,
    pageSize: 20,
    year: currentHospitalAstemYear.value
  })
    .then((res) => {
      rankingData.HOSPITAL_ASTEM = res && res.records ? res.records : []
    })
    .catch(() => (rankingData.HOSPITAL_ASTEM = []))

  universityRank({
    pageNum: 1,
    pageSize: 20,
    year: currentUniversityAstemYear.value
  })
    .then((res) => {
      rankingData.UNIVERSITY_ASTEM = res && res.records ? res.records : []
      handleTabChange(currentTable.value)
    })
    .catch(() => (rankingData.UNIVERSITY_ASTEM = []))
}

onMounted(async () => {
  getData()
  await setPV()
})
</script>

<style lang="scss" scoped>
.home {
  &-content {
    background: #fff;
  }
}
@media screen and (max-width: 500px) {
  .home {
    &-content {
      padding-top: 0 !important;
    }
  }
}
</style>
